import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { randomUUID } from "@azure/core-util";
import { ETagNone } from "./utils/constants";
import { tracingClient } from "./utils/tracing";
import { assertResponse } from "./utils/utils.common";
/**
 * A client that manages leases for a {@link ContainerClient} or a {@link BlobClient}.
 */

export var BlobLeaseClient = /*#__PURE__*/function () {
  /**
   * Creates an instance of BlobLeaseClient.
   * @param client - The client to make the lease operation requests.
   * @param leaseId - Initial proposed lease id.
   */
  function BlobLeaseClient(client, leaseId) {
    _classCallCheck(this, BlobLeaseClient);

    var clientContext = client.storageClientContext;
    this._url = client.url;

    if (client.name === undefined) {
      this._isContainer = true;
      this._containerOrBlobOperation = clientContext.container;
    } else {
      this._isContainer = false;
      this._containerOrBlobOperation = clientContext.blob;
    }

    if (!leaseId) {
      leaseId = randomUUID();
    }

    this._leaseId = leaseId;
  }
  /**
   * Establishes and manages a lock on a container for delete operations, or on a blob
   * for write and delete operations.
   * The lock duration can be 15 to 60 seconds, or can be infinite.
   * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-container
   * and
   * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-blob
   *
   * @param duration - Must be between 15 to 60 seconds, or infinite (-1)
   * @param options - option to configure lease management operations.
   * @returns Response data for acquire lease operation.
   */


  _createClass(BlobLeaseClient, [{
    key: "leaseId",
    get:
    /**
     * Gets the lease Id.
     *
     * @readonly
     */
    function get() {
      return this._leaseId;
    }
    /**
     * Gets the url.
     *
     * @readonly
     */

  }, {
    key: "url",
    get: function get() {
      return this._url;
    }
  }, {
    key: "acquireLease",
    value: function () {
      var _acquireLease = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(duration) {
        var _this = this;

        var options,
            _a,
            _b,
            _c,
            _d,
            _e,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                if (!(this._isContainer && (((_a = options.conditions) === null || _a === void 0 ? void 0 : _a.ifMatch) && ((_b = options.conditions) === null || _b === void 0 ? void 0 : _b.ifMatch) !== ETagNone || ((_c = options.conditions) === null || _c === void 0 ? void 0 : _c.ifNoneMatch) && ((_d = options.conditions) === null || _d === void 0 ? void 0 : _d.ifNoneMatch) !== ETagNone || ((_e = options.conditions) === null || _e === void 0 ? void 0 : _e.tagConditions)))) {
                  _context2.next = 3;
                  break;
                }

                throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");

              case 3:
                return _context2.abrupt("return", tracingClient.withSpan("BlobLeaseClient-acquireLease", options, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(updatedOptions) {
                    var _a;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.t0 = assertResponse;
                            _context.next = 3;
                            return _this._containerOrBlobOperation.acquireLease({
                              abortSignal: options.abortSignal,
                              duration: duration,
                              modifiedAccessConditions: Object.assign(Object.assign({}, options.conditions), {
                                ifTags: (_a = options.conditions) === null || _a === void 0 ? void 0 : _a.tagConditions
                              }),
                              proposedLeaseId: _this._leaseId,
                              tracingOptions: updatedOptions.tracingOptions
                            });

                          case 3:
                            _context.t1 = _context.sent;
                            return _context.abrupt("return", (0, _context.t0)(_context.t1));

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function acquireLease(_x) {
        return _acquireLease.apply(this, arguments);
      }

      return acquireLease;
    }()
    /**
     * To change the ID of the lease.
     * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-container
     * and
     * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-blob
     *
     * @param proposedLeaseId - the proposed new lease Id.
     * @param options - option to configure lease management operations.
     * @returns Response data for change lease operation.
     */

  }, {
    key: "changeLease",
    value: function () {
      var _changeLease = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(proposedLeaseId) {
        var _this2 = this;

        var options,
            _a,
            _b,
            _c,
            _d,
            _e,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};

                if (!(this._isContainer && (((_a = options.conditions) === null || _a === void 0 ? void 0 : _a.ifMatch) && ((_b = options.conditions) === null || _b === void 0 ? void 0 : _b.ifMatch) !== ETagNone || ((_c = options.conditions) === null || _c === void 0 ? void 0 : _c.ifNoneMatch) && ((_d = options.conditions) === null || _d === void 0 ? void 0 : _d.ifNoneMatch) !== ETagNone || ((_e = options.conditions) === null || _e === void 0 ? void 0 : _e.tagConditions)))) {
                  _context4.next = 3;
                  break;
                }

                throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");

              case 3:
                return _context4.abrupt("return", tracingClient.withSpan("BlobLeaseClient-changeLease", options, /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(updatedOptions) {
                    var _a, response;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.t0 = assertResponse;
                            _context3.next = 3;
                            return _this2._containerOrBlobOperation.changeLease(_this2._leaseId, proposedLeaseId, {
                              abortSignal: options.abortSignal,
                              modifiedAccessConditions: Object.assign(Object.assign({}, options.conditions), {
                                ifTags: (_a = options.conditions) === null || _a === void 0 ? void 0 : _a.tagConditions
                              }),
                              tracingOptions: updatedOptions.tracingOptions
                            });

                          case 3:
                            _context3.t1 = _context3.sent;
                            response = (0, _context3.t0)(_context3.t1);
                            _this2._leaseId = proposedLeaseId;
                            return _context3.abrupt("return", response);

                          case 7:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function changeLease(_x3) {
        return _changeLease.apply(this, arguments);
      }

      return changeLease;
    }()
    /**
     * To free the lease if it is no longer needed so that another client may
     * immediately acquire a lease against the container or the blob.
     * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-container
     * and
     * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-blob
     *
     * @param options - option to configure lease management operations.
     * @returns Response data for release lease operation.
     */

  }, {
    key: "releaseLease",
    value: function () {
      var _releaseLease = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this3 = this;

        var options,
            _a,
            _b,
            _c,
            _d,
            _e,
            _args6 = arguments;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                options = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};

                if (!(this._isContainer && (((_a = options.conditions) === null || _a === void 0 ? void 0 : _a.ifMatch) && ((_b = options.conditions) === null || _b === void 0 ? void 0 : _b.ifMatch) !== ETagNone || ((_c = options.conditions) === null || _c === void 0 ? void 0 : _c.ifNoneMatch) && ((_d = options.conditions) === null || _d === void 0 ? void 0 : _d.ifNoneMatch) !== ETagNone || ((_e = options.conditions) === null || _e === void 0 ? void 0 : _e.tagConditions)))) {
                  _context6.next = 3;
                  break;
                }

                throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");

              case 3:
                return _context6.abrupt("return", tracingClient.withSpan("BlobLeaseClient-releaseLease", options, /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(updatedOptions) {
                    var _a;

                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.t0 = assertResponse;
                            _context5.next = 3;
                            return _this3._containerOrBlobOperation.releaseLease(_this3._leaseId, {
                              abortSignal: options.abortSignal,
                              modifiedAccessConditions: Object.assign(Object.assign({}, options.conditions), {
                                ifTags: (_a = options.conditions) === null || _a === void 0 ? void 0 : _a.tagConditions
                              }),
                              tracingOptions: updatedOptions.tracingOptions
                            });

                          case 3:
                            _context5.t1 = _context5.sent;
                            return _context5.abrupt("return", (0, _context5.t0)(_context5.t1));

                          case 5:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x5) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function releaseLease() {
        return _releaseLease.apply(this, arguments);
      }

      return releaseLease;
    }()
    /**
     * To renew the lease.
     * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-container
     * and
     * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-blob
     *
     * @param options - Optional option to configure lease management operations.
     * @returns Response data for renew lease operation.
     */

  }, {
    key: "renewLease",
    value: function () {
      var _renewLease = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this4 = this;

        var options,
            _a,
            _b,
            _c,
            _d,
            _e,
            _args8 = arguments;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                options = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};

                if (!(this._isContainer && (((_a = options.conditions) === null || _a === void 0 ? void 0 : _a.ifMatch) && ((_b = options.conditions) === null || _b === void 0 ? void 0 : _b.ifMatch) !== ETagNone || ((_c = options.conditions) === null || _c === void 0 ? void 0 : _c.ifNoneMatch) && ((_d = options.conditions) === null || _d === void 0 ? void 0 : _d.ifNoneMatch) !== ETagNone || ((_e = options.conditions) === null || _e === void 0 ? void 0 : _e.tagConditions)))) {
                  _context8.next = 3;
                  break;
                }

                throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");

              case 3:
                return _context8.abrupt("return", tracingClient.withSpan("BlobLeaseClient-renewLease", options, /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(updatedOptions) {
                    var _a;

                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            return _context7.abrupt("return", _this4._containerOrBlobOperation.renewLease(_this4._leaseId, {
                              abortSignal: options.abortSignal,
                              modifiedAccessConditions: Object.assign(Object.assign({}, options.conditions), {
                                ifTags: (_a = options.conditions) === null || _a === void 0 ? void 0 : _a.tagConditions
                              }),
                              tracingOptions: updatedOptions.tracingOptions
                            }));

                          case 1:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x6) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function renewLease() {
        return _renewLease.apply(this, arguments);
      }

      return renewLease;
    }()
    /**
     * To end the lease but ensure that another client cannot acquire a new lease
     * until the current lease period has expired.
     * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-container
     * and
     * @see https://docs.microsoft.com/en-us/rest/api/storageservices/lease-blob
     *
     * @param breakPeriod - Break period
     * @param options - Optional options to configure lease management operations.
     * @returns Response data for break lease operation.
     */

  }, {
    key: "breakLease",
    value: function () {
      var _breakLease = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(breakPeriod) {
        var _this5 = this;

        var options,
            _a,
            _b,
            _c,
            _d,
            _e,
            _args10 = arguments;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                options = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};

                if (!(this._isContainer && (((_a = options.conditions) === null || _a === void 0 ? void 0 : _a.ifMatch) && ((_b = options.conditions) === null || _b === void 0 ? void 0 : _b.ifMatch) !== ETagNone || ((_c = options.conditions) === null || _c === void 0 ? void 0 : _c.ifNoneMatch) && ((_d = options.conditions) === null || _d === void 0 ? void 0 : _d.ifNoneMatch) !== ETagNone || ((_e = options.conditions) === null || _e === void 0 ? void 0 : _e.tagConditions)))) {
                  _context10.next = 3;
                  break;
                }

                throw new RangeError("The IfMatch, IfNoneMatch and tags access conditions are ignored by the service. Values other than undefined or their default values are not acceptable.");

              case 3:
                return _context10.abrupt("return", tracingClient.withSpan("BlobLeaseClient-breakLease", options, /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(updatedOptions) {
                    var _a, operationOptions;

                    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            operationOptions = {
                              abortSignal: options.abortSignal,
                              breakPeriod: breakPeriod,
                              modifiedAccessConditions: Object.assign(Object.assign({}, options.conditions), {
                                ifTags: (_a = options.conditions) === null || _a === void 0 ? void 0 : _a.tagConditions
                              }),
                              tracingOptions: updatedOptions.tracingOptions
                            };
                            _context9.t0 = assertResponse;
                            _context9.next = 4;
                            return _this5._containerOrBlobOperation.breakLease(operationOptions);

                          case 4:
                            _context9.t1 = _context9.sent;
                            return _context9.abrupt("return", (0, _context9.t0)(_context9.t1));

                          case 6:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9);
                  }));

                  return function (_x8) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function breakLease(_x7) {
        return _breakLease.apply(this, arguments);
      }

      return breakLease;
    }()
  }]);

  return BlobLeaseClient;
}();